import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isLoading", "isImgPreviewOpen", "className", "isEmojiEnabled", "hidden", "setDynamicFormHeight", "dispatch"];
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { motion } from 'framer-motion';
import { withRenderFlag } from '@beef/react';
import { cnBem } from "../../../../shared/lib";
import { TextArea } from "../../../../shared/ui";
import { selectImgPreviewTypeShow, selectIsImgPreviewOpen, selectIsLoading } from "../../../../entities/message/model";
import { selectIsFiltersVisible } from "../../../../entities/filters/model";
import { PlaceholderText } from "./constants";
import { addStoreDynamicFormHeight } from "../../../../entities/content/model";
import { useForm, useFormHeight } from "../../lib";
import { Attachment } from "../Attachment";
import { StickerButton } from "../StickerButton";
import { SubmitButton } from "../SubmitButton";
import styles from "./styles.pcss";
var cnForm = cnBem('form', styles);
var FormRender = function FormRender(props) {
  var isLoading = props.isLoading,
    isImgPreviewOpen = props.isImgPreviewOpen,
    className = props.className,
    isEmojiEnabled = props.isEmojiEnabled,
    hidden = props.hidden,
    setDynamicFormHeight = props.setDynamicFormHeight,
    _dispatch = props.dispatch,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useForm = useForm(),
    params = _useForm.params,
    isSubmitDisabled = _useForm.isSubmitDisabled,
    inputRef = _useForm.inputRef;
  var height = useFormHeight(inputRef);
  useEffect(function () {
    setDynamicFormHeight(height);
  }, [height]);
  return /*#__PURE__*/React.createElement(motion.form, _extends({
    animate: {
      height: height,
      y: hidden ? 200 : 0
    },
    className: cnForm({
      hidden: hidden
    }, [className]),
    transition: {
      y: {
        duration: 0.4
      },
      height: {
        duration: 0.01
      }
    }
  }, otherProps), /*#__PURE__*/React.createElement(Attachment, params.attachmentProps), /*#__PURE__*/React.createElement(TextArea, _extends({
    autoFocus: true,
    className: cnForm('text-area'),
    placeholder: isImgPreviewOpen ? PlaceholderText.imgPreview : PlaceholderText.textMessage,
    rightSide: isEmojiEnabled ? /*#__PURE__*/React.createElement(StickerButton, null) : undefined
  }, params.inputProps)), /*#__PURE__*/React.createElement(SubmitButton, _extends({
    hidden: isSubmitDisabled
  }, params.buttonProps)));
};
var mapStateToProps = function mapStateToProps(store) {
  return {
    isLoading: selectIsLoading(store),
    isEmojiEnabled: false,
    isImgPreviewOpen: selectIsImgPreviewOpen(store),
    hidden: selectIsFiltersVisible(store),
    shouldRender: !selectImgPreviewTypeShow(store)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDynamicFormHeight: function setDynamicFormHeight(height) {
      return dispatch(addStoreDynamicFormHeight(height));
    }
  };
};
export var Form = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(FormRender);